import React, {PureComponent} from 'react'
import injectSheet, {withTheme} from 'react-jss'
import CardGrid from '../Card/CardGrid'
import Section from '../Widgets/Section'
import SectionTitle from '../Widgets/SectionTitle'

class RelatedArticles extends PureComponent {

    render() {
        const {theme, related_articles} = this.props;
        if(! related_articles || !related_articles.length ) return null;

        return (
          <React.Fragment>
            <SectionTitle text='Related Stories' tag='h2' color={theme.colors.primary}/>
            <Section key='articles'>
                <CardGrid columns={2} items={related_articles} singleLine={false} variation='related' cardHeadingTag='h3'/>
            </Section>
          </React.Fragment>
        )
    }
}

export default injectSheet( (theme) => (
{
}))(withTheme(RelatedArticles))





// WEBPACK FOOTER //
// ./src/components/Article/RelatedArticles.js